import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import React from 'react';

const Component = props => {
  const { bodyHeight, children } = props;

  // wrapped with <tbody> <tr> <td> to avoid warnings on <table> childs
  return (
    <tbody>
    <tr>
      <td>
        <Grid sx={{ justifyContent: 'center', alignItems: 'center' }} container style={{ height: bodyHeight }}>
          <Grid size={10} style={{ height: '50%' }}>
            <Box display="flex" justifyContent="center" alignItems="center">
              {children}
            </Box>
          </Grid>
        </Grid>
      </td>
    </tr>
    </tbody>
  );
};

export default Component;

Component.propTypes = {
  bodyHeight: PropTypes.number.isRequired,
  children: PropTypes.element.isRequired
};
